export default (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    listContainer: {
        width: '100%',
        height: '100%',
        padding: '16px',
        paddingTop: '0px',
    },
    list: {
        '& .ag-header-viewport .ag-header-cell': {
            '&::after': {
                border: 'none !important',
            },
        },
        '& .row-tab, & .row-tab.ag-row-even': {
            backgroundColor: theme.colors.actionMinor[50],
            '& .w5-text-cell': {
                color: theme.colors.utility.textPrimary,
            },
            '& .w5-cell-container.w5-cell-container-custom-cell:nth-child(1)': {
                width: '100% !important',
                borderRight: 'none',
                '& .w5-cell .w5-text-cell': {
                    overflow: 'visible',
                },
            },
            '& .w5-cell-container .w5-cell.w5-cell--click': {
                cursor: 'auto',
            },
        },
        '& .w5-icon-cell-wrapper svg': {
            width: 18,
            height: 18,
        },
        '& .w5-icon-cell-true path': {
            fill: theme.colors.semantic.positive500,
        },
        '&.ag-theme-balham': {
            '& .ag-cell': {
                paddingRight: 0,
                '&.fieldType': {
                    paddingRight: 0,
                },
                '&.check-icons': {
                    paddingLeft: 5,
                    paddingRight: 5,
                },
            },
            '& .ag-header-cell': {
                '&.check-icons': {
                    paddingLeft: 5,
                    paddingRight: 5,
                },
            },
        },
    },
    searchBar: {
        minWidth: 356,
    },
});
